import React, { useEffect, useMemo, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim'; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.
import style from './style.module.scss';

const ParticlesWrapper = () => {
    const [init, setInit] = useState(false);

    // this should be run only once per application lifetime
    useEffect(() => {
        initParticlesEngine(async (engine) => {
            // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
            // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
            // starting from v2 you can add only the features you need reducing the bundle size
            //await loadAll(engine);
            //await loadFull(engine);
            await loadSlim(engine);
            //await loadBasic(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const options = useMemo(
        () => ({
            particles: {
                color: {
                    value: ['#1E00FF', '#FF0061', '#E1FF00', '#00FF9E'],
                },
                move: {
                    decay: 0.05,
                    direction: 'top',
                    enable: true,
                    gravity: {
                        enable: true,
                        acceleration: 25,
                    },
                    outModes: {
                        default: 'destroy',
                        top: 'none',
                    },
                    speed: {
                        min: 33,
                        max: 66,
                    },
                },
                number: {
                    value: 100,
                },
                opacity: {
                    value: 1,
                },
            },
        }),
        [],
    );

    if (init) {
        return (
            <div className={style.particles}>
                <Particles options={options} />
            </div>
        );
    }

    return <></>;
};

export default ParticlesWrapper;
